<template>
  <form @submit.prevent="submit" :class="errorClass">

    <p>An access code will allow a surgeon to associate their account with yours. Generate a code
      and give it to your surgeon along with your e-mail address. Codes can only be used once and
      will expire after one week.</p>

    <rp-button :disabled="isInvalid" type="primary">Generate Access Code</rp-button><br/>

    <p v-if="resource.result">Your access code is:</p>
    <h1>{{resource.result}}</h1>

  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import form from '../../../mixins/form'
  import Button from '../../../components/ui/inputs/Button'

  export default {
    name: 'GenerateAccessCode',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button
    },

    props: {
    },

    computed: {
    },

    methods: {
    },

    validations: {
    }
  }
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/GenerateAccessCode.vue